/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discounts_Unit_PercentageInputs */

const en_admin_discounts_unit_percentage = /** @type {(inputs: Admin_Discounts_Unit_PercentageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentage`)
};

const de_admin_discounts_unit_percentage = /** @type {(inputs: Admin_Discounts_Unit_PercentageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prozent`)
};

const es_admin_discounts_unit_percentage = /** @type {(inputs: Admin_Discounts_Unit_PercentageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porcentaje`)
};

const fr_admin_discounts_unit_percentage = /** @type {(inputs: Admin_Discounts_Unit_PercentageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourcentage`)
};

const nl_admin_discounts_unit_percentage = /** @type {(inputs: Admin_Discounts_Unit_PercentageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentage`)
};

/** @type {(inputs: Admin_Discounts_Unit_PercentageInputs) => LocalizedString} */
const it_admin_discounts_unit_percentage = en_admin_discounts_unit_percentage;

/** @type {(inputs: Admin_Discounts_Unit_PercentageInputs) => LocalizedString} */
const pt_br2_admin_discounts_unit_percentage = en_admin_discounts_unit_percentage;

/** @type {(inputs: Admin_Discounts_Unit_PercentageInputs) => LocalizedString} */
const pl_admin_discounts_unit_percentage = en_admin_discounts_unit_percentage;

/** @type {(inputs: Admin_Discounts_Unit_PercentageInputs) => LocalizedString} */
const hu_admin_discounts_unit_percentage = en_admin_discounts_unit_percentage;

/** @type {(inputs: Admin_Discounts_Unit_PercentageInputs) => LocalizedString} */
const ro_admin_discounts_unit_percentage = en_admin_discounts_unit_percentage;

/**
* | output |
* | --- |
* | "Percentage" |
*
* @param {Admin_Discounts_Unit_PercentageInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discounts_unit_percentage = /** @type {((inputs?: Admin_Discounts_Unit_PercentageInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discounts_Unit_PercentageInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discounts_unit_percentage(inputs)
	if (locale === "de") return de_admin_discounts_unit_percentage(inputs)
	if (locale === "es") return es_admin_discounts_unit_percentage(inputs)
	if (locale === "fr") return fr_admin_discounts_unit_percentage(inputs)
	if (locale === "nl") return nl_admin_discounts_unit_percentage(inputs)
	if (locale === "it") return it_admin_discounts_unit_percentage(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discounts_unit_percentage(inputs)
	if (locale === "pl") return pl_admin_discounts_unit_percentage(inputs)
	if (locale === "hu") return hu_admin_discounts_unit_percentage(inputs)
	return ro_admin_discounts_unit_percentage(inputs)
});
export { admin_discounts_unit_percentage as "admin.discounts.unit_percentage" }